export default __webpack_public_path__ + "static/heroku-classic-dfe5f14ec3128e917320565178a7dd25.png";